jQuery(function($) {
  const expirationDuration = 1000 * 60 * 60 * 24 * 7; // 1 week
  const prevAccepted = localStorage.getItem('accepted');
  const currentTime = new Date().getTime();
  const notAccepted = prevAccepted === undefined;
  const prevAcceptedExpired = prevAccepted !== undefined && currentTime - prevAccepted > expirationDuration;
  const newAlert = prevAccepted !== undefined && lastAlert > prevAccepted;

  $('#js-close-alert').click(function() {
    $(this).parent().parent().remove();
    localStorage.setItem('accepted', currentTime);
  });

  if (notAccepted || prevAcceptedExpired || newAlert) {
    $('.alert').removeClass('hide');
  }
});
